module.exports = __webpack_public_path__ + "media/images/logo-text-0d27686e77bdaa4213e2f58caab85cc6.png";